/* Beneos reusable add-to-cart for shop_pseudo_products OUTSIDE the PDP buy box
   (shop browser tiles, future search results). Same Spec-8 flow as the PDP
   (beneos-commerce.js): resolve the cloud_products live, add qty x price_class
   variant lines with the hidden _cloud_upload_ids property plus the _pack_*
   drawer props, then refresh + open the cart drawer.

   window.BeneosCartAdd.add(cloudProductIds, meta) -> Promise<'added'|'owned'|'error'>
     cloudProductIds: array of cloud_product ids (or comma-joined string)
     meta: { title, url, thumb, summary, packLabel, proxyUrl } (all optional) */
(function () {
  'use strict';
  if (window.BeneosCartAdd) return;

  function numId(gid) { return String(gid == null ? '' : gid).replace(/\D/g, ''); }

  function add(cloudProductIds, meta) {
    meta = meta || {};
    var cps = Array.isArray(cloudProductIds) ? cloudProductIds : String(cloudProductIds || '').split(',');
    cps = cps.map(function (s) { return String(s).trim(); }).filter(Boolean);
    if (!cps.length) return Promise.resolve('error');

    var B = window.Beneos || {};
    var routes = B.routes || {};
    var proxyUrl = meta.proxyUrl || '/apps/beneos/library';
    var url = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') +
      'resource=resolve&cp=' + encodeURIComponent(cps.join(','));

    return fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = (j && j.data) || {};
        var groups = d.groups || [];
        if (!groups.length) {
          // fully owned (or nothing sellable): never add an empty/free line
          return ((d.total_uploads || 0) > 0) ? 'owned' : 'error';
        }
        var missing = d.missing || [];
        var idsByVariant = {};
        missing.forEach(function (it) {
          var v = numId(it.variant_id);
          (idsByVariant[v] = idsByVariant[v] || []).push(it.id);
        });
        var packTitle = meta.title || '';
        var packLabel = meta.packLabel || 'Pack';
        var summary = meta.summary || '';
        var visibleValue = summary ? (packTitle + ': ' + summary) : packTitle;
        var items = groups.map(function (g) {
          var v = numId(g.variant_id);
          var props = {};
          props['_cloud_upload_ids'] = (idsByVariant[v] || []).join(',');
          if (visibleValue) props[packLabel] = visibleValue;
          if (packTitle) props['_pack_title'] = packTitle;
          if (meta.url) props['_pack_url'] = meta.url;
          if (meta.thumb) props['_pack_thumb'] = meta.thumb;
          if (summary) props['_pack_summary'] = summary;
          return { id: v, quantity: g.qty, properties: props };
        });
        return fetch((routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
          .then(function () { return (B.cart && B.cart.refresh) ? B.cart.refresh() : null; })
          .then(function () {
            if (B.cart && B.cart.open) B.cart.open();
            return 'added';
          });
      })
      .catch(function () { return 'error'; });
  }

  window.BeneosCartAdd = { add: add };
})();
